<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Select Event Type</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label for="searchEventTypesInput">Search Event Types</label>
      <input type="text" class="form-control" id="searchEventTypesInput"
             name="searchEventTypesInput"
             ngbAutofocus
             [(ngModel)]="searchInput"
             (ngModelChange)="handleSearchInputChange()">
    </div>

    <!-- Add a fixed-height div to prevent the modal from shifting as results are loaded -->
    <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto">

      <table class="table table-bordered table-hover"
             *ngIf="selectedEventType === null">
        <tbody *ngIf="loadingEventTypes">
          <tr>
            <td colspan="99">
              Loading...
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!loadingEventTypes">
          <tr *ngIf="filteredEventTypes().length === 0">
            <td colspan="99" class="text-muted">
              No event types
              <span *ngIf="searchInput !== ''">matching search</span>
            </td>
          </tr>
          <tr style="cursor:pointer"
              *ngFor="let eventType of filteredEventTypes()"
              (click)="selectEventType(eventType)">
            <td>
              {{ eventType.name }}
              <span *ngIf="eventType.status !== EventTypeStatus.active">
                ({{ getEventTypeStatusDisplay(eventType.status) }})
              </span>
            </td>
          </tr>
        </tbody>
      </table>

    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            (click)="handleSave()"
            [disabled]="!validInputSelected()"
            [class.disabled]="!validInputSelected()">
      Submit
    </button>
  </div>

</ng-container>
